import * as LabelPrimitive from "@radix-ui/react-label";
import { Slot } from "@radix-ui/react-slot";
import React from "react";

import { useFormItemId } from "@/components/ui/form";
import { Label } from "@/components/ui/label";

// We don't use react-hook-form, because we don't need all the cool stuff it
// does, and we want to update the state for every change, not have a `onSubmit`
// (also https://react-hook-form.com/ was down when I wrote this :) )

// Simplified FormLabel that does not require react-hook-form
export const FormLabel = React.forwardRef<
    React.ElementRef<typeof LabelPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ ...props }, ref) => {
    const formItemId = useFormItemId();

    return <Label ref={ref} htmlFor={formItemId} {...props} />;
});

// Simplified FormControl that does not require react-hook-form
export const FormControl = React.forwardRef<
    React.ElementRef<typeof Slot>,
    React.ComponentPropsWithoutRef<typeof Slot>
>(({ ...props }, ref) => {
    const formItemId = useFormItemId();

    return <Slot ref={ref} id={formItemId} {...props} />;
});
